module.exports = __webpack_public_path__ + "img/icon-edit-page.8332bf81.svg";